export const getCredentialType = (credentialType) => {
  switch (credentialType) {
    case 1:
      return "Certificate of Completion";
    case 2:
      return "Microcredential";
    case 3:
      return "Badge";
  }
};
